module.exports = __webpack_public_path__ + "img/paymentCreditCard.d8507b71.svg";